import * as angular from 'angular';
import { mixinTranslation } from '../app.common/translation';
import '../app.retailer.common';
import '../window';
import './styles.less';

angular.module('app.common')
    .value('localStorageAuthKey', 'retailerAuthorizationData')
    .value('customAuthHeaders', null);

const module = angular.module('naut', ['ngRoute', 'ngAnimate', 'ngStorage', 'ngCookies', 'ngSanitize', 'ngResource', 'ui.bootstrap', 'ui.router',
    'ui.utils', 'cfp.loadingBar', 'toaster', 'ngTable', 'xeditable', 'textAngular', 'angularFileUpload', 'angular.filter', 'mrImage',
    'angularMoment', 'ui.select', 'angular-flot', 'ui.map', 'app.common', 'ui.sortable', 'app.retailes.common', 'pascalprecht.translate', 'ui.tree']);

module.value('siteAddressUrl', siteUrl);
module.value('retailerServiceUrl', retailerApiUrl);
module.value('jispPayServiceUrl', jispPayApiUrl);
module.value('googleMapsAPIKey', googleMapsApiKey);
module.value('imageServiceUrl', retailerApiUrl);
module.value('siteRetailerHomeUrl', siteRetailerHomeUrl);
module.value('apiCDNUrlRetailer', retailerApiCDNUrl);
module.value('apiAdminCDNUrl', adminApiCDNUrl);

const tsContext = require.context('.', true, /\.ts$/);
tsContext.keys().forEach(tsContext);

module.config(configSce);

mixinTranslation(module, ['en', 'no'], 'retailer');

configSce.$inject = ['$sceDelegateProvider'];
function configSce($sce: ng.ISCEDelegateProvider) {
    $sce.resourceUrlWhitelist(['self', `${retailerApiUrl}**`]);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/index.ts